import React, { useState } from 'react'
import { Container, Grid, Typography, Box, ListItem, ListItemIcon, useMediaQuery, makeStyles, Button, Hidden } from '@material-ui/core'
import { useRouter } from 'next/router'
import i18n from 'i18next'
import { Trans } from 'react-i18next'
import Link from 'next/link'
import bluebird from 'bluebird'
import redis from 'redis'
import Layout from '../../components/layout'
import { useAuth } from '../../components/context/useFetch'
import allPagesProps from '../../components/common/all_pages_props'

const atoi = (addr) => {
  const parts = addr.split('.').map((str) => parseInt(str))

  return (parts[0] ? parts[0] << 24 : 0) + (parts[1] ? parts[1] << 16 : 0) + (parts[2] ? parts[2] << 8 : 0) + parts[3]
}

const checkIpaddrInRange = (ipaddr, start, end) => {
  const num = atoi(ipaddr)
  return num >= atoi(start) && num <= atoi(end)
}

export const getCountryCodeFromIp = async (ip) => {
  bluebird.promisifyAll(redis.RedisClient.prototype)
  const cache = redis.createClient({ host: 'redis' })
  let countryIpRanges = []

  await cache.existsAsync('country_ip_ranges').then(async (reply) => {
    if (reply !== 1) {
      return true
    } else {
      countryIpRanges = JSON.parse(await cache.getAsync('country_ip_ranges'))['DZ'] || []
    }
  })

  return countryIpRanges.some((address) => checkIpaddrInRange(ip, address[0].toString(), address[1].toString()))
}

export const getServerSideProps = async (context) => {
  return {
    props: await allPagesProps(context)
  }
}

const useStyles = makeStyles((theme) => ({
  picture: {
    [theme.breakpoints.down('750')]: {
      width: '100%'
    },
    [theme.breakpoints.between('750', '1000')]: {
      width: '35%'
    },
    [theme.breakpoints.between('1000', 'lg')]: {
      width: '25%'
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      width: '20%'
    }
  },
  texte: {
    [theme.breakpoints.down('750')]: {
      width: '100%'
    },
    [theme.breakpoints.between('750', '1000')]: {
      width: '65%'
    },
    [theme.breakpoints.between('1000', 'lg')]: {
      width: '75%'
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      width: '80%'
    }
  },
  opinion: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      width: '85%'
    },
    [theme.breakpoints.between('lg', '1490')]: {
      width: '70%'
    },
    [theme.breakpoints.up('1490')]: {
      width: '65%'
    }
  },
  h5: {
    '& span': {
      fontWeight: 'bold'
    }
  }
}))

const LandingPage = ({ countryCode }) => (
  <div style={{ backgroundColor: 'white' }}>
    <Layout>
      <Grid
        container
        spacing={10}
        style={{
          marginTop: '10px'
        }}
        align="center">
        <Grid item xs={12}>
          <Hero countryCode={countryCode} />
        </Grid>

        <Grid item xs={12}>
          <HiringReasons />
        </Grid>

        <Grid item xs={12}>
          <OurPackages />
        </Grid>

        <Grid item xs={12}>
          <Recognition />
        </Grid>

        <Grid item xs={12}>
          <HowItWorks />
        </Grid>

        <Grid item xs={12}>
          <NewsLetter />
        </Grid>
      </Grid>
    </Layout>
  </div>
)

const reasons = {
  1: {
    icon: '/chat_bubble.png',
    title: i18n.t('landing_page.main.hiring_reasons.1.title'),
    content: i18n.t('landing_page.main.hiring_reasons.1.content'),
    idx: 1
  },
  2: {
    icon: '/currency.png',
    title: i18n.t('landing_page.main.hiring_reasons.2.title'),
    content: i18n.t('landing_page.main.hiring_reasons.2.content'),
    idx: 2
  },
  3: {
    icon: '/search.png',
    title: i18n.t('landing_page.main.hiring_reasons.3.title'),
    content: i18n.t('landing_page.main.hiring_reasons.3.content'),
    idx: 3
  },
  4: {
    icon: '/chart.png',
    title: i18n.t('landing_page.main.hiring_reasons.4.title'),
    content: i18n.t('landing_page.main.hiring_reasons.4.content'),
    idx: 4
  },
  5: {
    icon: '/users_linking.png',
    title: i18n.t('landing_page.main.hiring_reasons.5.title'),
    content: i18n.t('landing_page.main.hiring_reasons.5.content'),
    idx: 5
  }
}

const HiringReasons = () => (
  <Container>
    <Typography variant="h1" align="center">
      {i18n.t('landing_page.main.hiring_reasons.title')}
    </Typography>

    <Grid container spacing={4} justifyContent="center">
      {Object.values(reasons).map((reason) => (
        <Grid item xs={12} sm={6} md={4}>
          <ReasonCard reason={reason} />
        </Grid>
      ))}
    </Grid>
  </Container>
)

const ReasonCard = ({ reason }) => {
  const classes = useStyles()

  return (
    <Box
      style={{
        background:
          reason.idx % 2 !== 0
            ? 'linear-gradient(90deg, rgba(0, 125, 252, 1) 0%, rgba(0, 119, 240, 1) 8.01%, rgba(0, 107, 215, 1) 29.27%, rgba(0, 98, 196, 1) 51.28%, rgba(0, 93, 186, 1) 74.31%, rgba(0, 91, 182, 1) 100%)'
            : 'linear-gradient(90deg, rgba(253, 112, 82, 1) 0%, rgba(227, 60, 51, 1) 100%)',
        width: '220px',
        height: '339.12px',
        borderRadius: '30px',
        transform: 'rotate(165.25deg)'
      }}>
      <Box
        style={{
          background: 'rgba(255, 255, 255, 1);',
          backgroundColor: 'white',
          width: '194px',
          height: '335px',
          borderRadius: '30px',
          transform: 'rotate(10deg)',
          position: 'absolute',
          left: '10px',
          top: '5px'
        }}>
        <Box
          style={{
            transform: 'rotate(185deg)',
            paddingBottom: '65%',
            paddingLeft: '5%'
          }}>
          <Grid container spacing={2} align="center" alignItems="center">
            <Grid item xs={12}>
              <img alt="icon" src={reason.icon} align="left" />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h4"
                style={{
                  fontWeight: 'bold',
                  minHeight: '50px'
                }}
                align="center">
                {reason.title}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                align="center"
                className={classes.h5}
                style={{
                  minHeight: '100px'
                }}
                dangerouslySetInnerHTML={{ __html: reason.content }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}

const pricingDetails = {
  freemium: {
    idx: 0,
    title: i18n.t('landing_page.main.pricing.freemium.title'),
    text1: i18n.t('landing_page.main.pricing.freemium.text1'),
    text2: i18n.t('landing_page.main.pricing.freemium.text2'),
    text3: i18n.t('landing_page.main.pricing.freemium.text3'),
    text4: '',
    action: i18n.t('landing_page.main.pricing.freemium.action')
  },
  job_post: {
    idx: 1,
    title: i18n.t('landing_page.main.pricing.job_post.title'),
    text1: i18n.t('landing_page.main.pricing.job_post.text1'),
    text2: i18n.t('landing_page.main.pricing.job_post.text2'),
    text3: i18n.t('landing_page.main.pricing.job_post.text3'),
    text4: i18n.t('landing_page.main.pricing.job_post.text4'),
    action: i18n.t('landing_page.main.pricing.job_post.action')
  },
  head_hunting: {
    idx: 2,
    title: i18n.t('landing_page.main.pricing.head_hunting.title'),
    text1: i18n.t('landing_page.main.pricing.head_hunting.text1'),
    text2: i18n.t('landing_page.main.pricing.head_hunting.text2'),
    text3: i18n.t('landing_page.main.pricing.head_hunting.text3'),
    text4: i18n.t('landing_page.main.pricing.head_hunting.text4'),
    action: i18n.t('landing_page.main.pricing.head_hunting.action')
  }
}

const OurPackages = () => (
  <Container>
    <Typography variant="h1" align="center">
      {i18n.t('landing_page.main.pricing.title')}
    </Typography>
    <Grid container spacing={2} justifyContent="center">
      {Object.values(pricingDetails).map((item) => (
        <Grid item xs={12} sm={6} md={4}>
          <SinglePackage item={item} />
        </Grid>
      ))}
    </Grid>
  </Container>
)

const SinglePackage = ({ item }) => {
  const router = useRouter()

  return (
    <Box
      style={{
        height: '500px',
        width: '286px',
        backgroundColor: 'white',
        border: '2px solid rgba(208, 208, 208, 0.3)',
        borderRadius: '20px',
        zIndex: 10
      }}>
      <Box
        style={{
          height: '95px',
          width: '300px',
          background: 'linear-gradient(251.67deg, #94DBFE 6.23%, #7EC8F3 12.46%, #58A6DF 25.23%, #388ACF 38.5%, #1F75C3 52.21%, #0E65BA 66.54%, #035CB5 81.87%, #0059B3 100%)',
          borderTopRightRadius: '50px',
          borderBottomRightRadius: '50px',
          borderTopLeftRadius: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '35px',
          marginLeft: '-40px',
          zIndex: 20
        }}>
        <Typography
          style={{
            color: 'white',
            fontWeight: '700',
            fontSize: '32px'
          }}>
          {item.title}
        </Typography>
      </Box>

      <Box
        style={{
          height: '30px',
          width: '40px',
          background: '#0059B3',
          position: 'absolute',
          marginLeft: '-40px',
          zIndex: 5
        }}
      />

      <Box
        style={{
          height: '60px',
          width: '40px',
          backgroundColor: '#73bfee',
          borderTopLeftRadius: '30px',
          borderBottomLeftRadius: '30px',
          position: 'absolute',
          marginLeft: '-40px',
          zIndex: 10
        }}
      />

      <Grid
        container
        spacing={3}
        justifyContent="space-between"
        textAlign="center"
        style={{
          marginTop: '15%',
          minHeight: '230px'
        }}>
        <Grid item xs={12}>
          <Typography
            align="center"
            style={{
              fontWeight: '500',
              color: '#3C3C39'
            }}>
            {item.text1}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            align="center"
            style={{
              fontWeight: '500',
              color: '#3C3C39'
            }}>
            {item.text2}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            align="center"
            style={{
              fontWeight: '500',
              color: '#3C3C39'
            }}>
            {item.text3}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            align="center"
            style={{
              fontWeight: '500',
              color: '#3C3C39'
            }}>
            {item.text4}
          </Typography>
        </Grid>
      </Grid>

      <Box
        style={{
          height: '128px',
          width: '155px',
          background: 'linear-gradient(250.7deg, #94DBFE 1.37%, #7EC8F3 9.45%, #58A6DF 25.98%, #388ACF 43.16%, #1F75C3 60.9%, #0E65BA 79.45%, #035CB5 99.3%, #0059B3 122.77%)',
          marginTop: '15px',
          marginLeft: '135px',
          position: 'absolute'
        }}
      />

      <Box
        style={{
          height: '128px',
          width: '286px',
          borderRight: '2px solid rgba(208, 208, 208, 0.3)',
          borderBottom: '2px solid rgba(208, 208, 208, 0.3)',
          backgroundColor: 'white',
          borderBottomRightRadius: '20px',
          marginTop: '10px',
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <a href="/hire-developer/pricing" style={{ textDecoration: 'none' }}>
          <Link
            href={{
              pathname: '/hire-developer/pricing',
              query: {
                choice: item.idx
              }
            }}>
            <Box
              style={{
                background: 'linear-gradient(180deg, #E33C33 0%, #FD7052 100%)',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                borderRadius: '25px',
                width: '211px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              <Button
                style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  color: 'white'
                }}>
                {item.action}
              </Button>
            </Box>
          </Link>
        </a>
      </Box>
    </Box>
  )
}

export const opinionsList = {
  1: {
    frame: '/blue_frame.svg',
    profile_picture: '/Fatiha.svg',
    name: 'Fatiha Ziouani',
    job: i18n.t('landing_page.main.recognition.1.job'),
    opinion: i18n.t('landing_page.main.recognition.1.opinion')
  },
  2: {
    frame: '/orange_frame.svg',
    profile_picture: '/Hugo.svg',
    name: 'Hugo.B',
    job: i18n.t('landing_page.main.recognition.2.job'),
    opinion: i18n.t('landing_page.main.recognition.2.opinion')
  },
  3: {
    frame: '/orange_frame.svg',
    job: i18n.t('landing_page.main.recognition.3.job'),
    opinion: i18n.t('landing_page.main.recognition.3.opinion')
  }
}

const MAX_LENGTH = 170

const ELEMENTS_TO_DISPLAY_IN_LP = 2

export const Recognition = () => {
  const [showMore, setShowMore] = useState(false)

  return (
    <div style={{ padding: '20px', backgroundColor: 'rgba(225, 234, 240, 1)' }}>
      <Container>
        <Typography variant="h1" align="center">
          {i18n.t('landing_page.main.recognition.title')}
        </Typography>

        <Grid container spacing={2} justifyContent="space-between">
          {Object.values(opinionsList)
            .slice(0, ELEMENTS_TO_DISPLAY_IN_LP)
            .map((item) => (
              <Grid item xs={12} md={6}>
                <RecognitionItem item={item} showMore={showMore} setShowMore={(value) => setShowMore(value)} />
              </Grid>
            ))}
        </Grid>
      </Container>
    </div>
  )
}

export const RecognitionItem = ({ item, showMore, setShowMore }) => {
  const minWidth = useMediaQuery('(min-width:750px)')
  const maxWidth = useMediaQuery('(max-width:960px)')

  const isMobile = useMediaQuery('(max-width:750px)')

  const router = useRouter()
  const inPricingPage = router.pathname.includes('pricing')

  const classes = useStyles()

  return (
    <Box
      style={{
        minHeight: '50vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
      <div
        style={{
          minHeight: '50vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: !isMobile ? `url('${item.frame}')` : '',
          backgroundRepeat: 'no-repeat'
        }}>
        <Grid
          container
          justifyContent={minWidth && maxWidth ? 'flex-start' : 'center'}
          alignItems="center"
          spacing={12}
          style={{
            maxHeight: '500px',
            marginBottom: '8vh',
            marginLeft: minWidth && maxWidth ? '4vh' : '0'
          }}>
          <Grid
            item
            className={classes.picture}
            style={{
              display: item?.profile_picture ? 'flex' : 'none'
            }}>
            <Box>
              <div
                style={{
                  height: '120px',
                  width: '122px',
                  borderRadius: '100px',
                  backgroundImage: item?.profile_picture ? `url('${item.profile_picture}')` : null
                }}
              />
            </Box>
          </Grid>
          <Grid item className={classes.texte}>
            <Typography
              align={isMobile ? 'center' : 'left'}
              style={{
                fontWeight: 'bolder'
              }}>
              {item?.name && item.name}
            </Typography>
            <Typography
              align={isMobile ? 'center' : 'left'}
              style={{
                fontWeight: 'bolder'
              }}>
              {item.job}
            </Typography>
          </Grid>
          <Grid item xs={!inPricingPage ? 10 : 12}>
            <Typography className={classes.opinion}>{showMore ? item.opinion : `${item.opinion.slice(0, MAX_LENGTH)} ...`}</Typography>
            {item.opinion.length > MAX_LENGTH && <a onClick={() => setShowMore(!showMore)}>Lire la suite</a>}
          </Grid>
        </Grid>
      </div>
    </Box>
  )
}

const processList = {
  1: {
    title: i18n.t('landing_page.main.how_it_works.1.title'),
    sub_title: i18n.t('landing_page.main.how_it_works.1.sub_title'),
    description: i18n.t('landing_page.main.how_it_works.1.description'),
    icon: '/gaining_time.svg'
  },
  2: {
    title: i18n.t('landing_page.main.how_it_works.2.title'),
    sub_title: i18n.t('landing_page.main.how_it_works.2.sub_title'),
    description: i18n.t('landing_page.main.how_it_works.2.description'),
    icon: '/selection.svg'
  },
  3: {
    title: i18n.t('landing_page.main.how_it_works.3.title'),
    sub_title: i18n.t('landing_page.main.how_it_works.3.sub_title'),
    description: i18n.t('landing_page.main.how_it_works.3.description'),
    icon: '/qualifications.svg'
  }
}

const HowItWorks = () => (
  <div>
    <Container>
      <Typography variant="h1" align="center">
        {i18n.t('landing_page.main.how_it_works.title')}
      </Typography>

      <Grid container spacing={8} justifyContent="center">
        <Grid item xs={12}>
          <Typography
            align="center"
            style={{
              color: '#3C3C39',
              fontSize: '30px'
            }}>
            {i18n.t('landing_page.main.how_it_works.sub_title')}
          </Typography>
        </Grid>

        {Object.values(processList).map((item, idx) => (
          <Grid item xs={12}>
            {idx % 2 === 0 ? <LeftItem item={item} /> : <RightItem item={item} />}
          </Grid>
        ))}
      </Grid>
    </Container>
  </div>
)

const RightItem = ({ item }) => {
  const isMobile = useMediaQuery('(max-width:600px)')
  const isLarge = useMediaQuery('(min-width:1200px)')

  return (
    <Grid container spacing={4} justifyContent="flex-end">
      <Grid item xs={isMobile ? 11 : 10} sm={9.5} md={8}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '700px'
          }}>
          <Typography variant="h3" align="right">
            {item.title}
          </Typography>

          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'right',
              marginTop: '20px'
            }}>
            <Typography
              style={{
                marginRight: '20px',
                fontSize: '20px'
              }}>
              {item.sub_title}
            </Typography>

            <img src="/orange_arrow.svg" alt="arrow" />
          </Box>

          <Typography
            style={{
              marginTop: '20px',
              fontSize: '20px'
            }}>
            {item.description}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={isMobile ? 0 : 2} sm={2.5}>
        <ListItem
          style={{
            display: isMobile ? 'none' : 'flex',
            marginLeft: isLarge ? '-50px' : '0px'
          }}>
          <ListItemIcon>
            <Box
              sx={{
                backgroundColor: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '20px'
              }}>
              <img height="90px" width="90px" src={item.icon} alt="arrow" />
            </Box>
          </ListItemIcon>
        </ListItem>
      </Grid>
    </Grid>
  )
}

const LeftItem = ({ item }) => {
  const isMobile = useMediaQuery('(max-width:600px)')
  const minWidth = useMediaQuery('(min-width:600px)')
  const maxWidth = useMediaQuery('(max-width:800px)')

  return (
    <Grid container spacing={4}>
      <Grid item xs={isMobile ? 0 : 2} sm={2.5}>
        <ListItem
          style={{
            display: isMobile ? 'none' : 'flex'
          }}>
          <ListItemIcon>
            <Box
              sx={{
                backgroundColor: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '20px'
              }}>
              <img height="90px" width="90px" src={item.icon} alt="arrow" />
            </Box>
          </ListItemIcon>
        </ListItem>
      </Grid>
      <Grid item xs={isMobile ? 11 : 10} sm={9.5} md={9}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '700px',
            marginLeft: minWidth && maxWidth ? '30px' : '0px'
          }}>
          <Typography variant="h3">{item.title}</Typography>

          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginTop: '20px'
            }}>
            <img src="/blue_arrow.svg" alt="arrow" />

            <Typography
              style={{
                marginLeft: '20px',
                fontSize: '20px'
              }}>
              {item.sub_title}
            </Typography>
          </Box>

          <Typography
            style={{
              marginTop: '20px',
              display: 'block',
              fontSize: '20px'
            }}>
            {item.description}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}

const benefitsList = {
  1: {
    text: i18n.t('landing_page.main.newsletter.1')
  },
  2: {
    text: i18n.t('landing_page.main.newsletter.2')
  },
  3: {
    text: i18n.t('landing_page.main.newsletter.3')
  }
}

const NewsLetter = () => {
  const isMobile = useMediaQuery('(max-width:800px)')

  return (
    <div style={{ padding: '20px', backgroundColor: 'rgba(225, 234, 240, 1)' }}>
      <Container>
        <Typography variant="h1" align="center">
          {i18n.t('landing_page.main.newsletter.title')}
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <Typography
              align="left"
              style={{
                fontSize: '20px',
                marginLeft: isMobile ? '50px' : '0px'
              }}>
              {i18n.t('landing_page.main.newsletter.sub_title')}
            </Typography>
          </Grid>
          <Grid item xs={8} md={6}>
            {Object.values(benefitsList).map((item) => (
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginTop: '20px'
                }}>
                <img src="/blue_arrow.svg" alt="arrow" />

                <Typography
                  style={{
                    marginLeft: '20px',
                    fontSize: '20px'
                  }}>
                  {item.text}
                </Typography>
              </Box>
            ))}

            <Box
              id="hire-subscribe"
              style={{
                background: 'linear-gradient(180deg, #E33C33 0%, #FD7052 100%)',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                borderRadius: '25px',
                width: '211px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '100px',
                cursor: 'pointer'
              }}>
              <Typography
                align="center"
                style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  color: 'white'
                }}>
                {i18n.t('landing_page.main.newsletter.action')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={2} md={6}>
            <Box
              sx={{
                display: isMobile ? 'none' : 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
              <img src="/Newsletter.svg" alt="arrow" />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

const useHeroStyles = makeStyles({
  h1: {
    fontSize: '54px',
    lineHeight: '60px',
    paddingBottom: 0,
    marginBottom: 0,
    '& u': {
      background: 'linear-gradient(to right, #007FFF, #0059B2)',
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent'
    }
  }
})

export const Hero = ({ countryCode }) => {
  const classes = useHeroStyles()

  const auth = useAuth()

  const isForeign = !countryCode

  return (
    <div style={{ backgroundColor: 'white' }}>
      <Container>
        <Grid container alignItems="center" spacing={5}>
          <Grid item xs={12} sm={5}>
            <Box py={5}>
              <Grid container direction="row">
                <Grid item>
                  <Typography
                    variant="h1"
                    className={classes.h1}
                    dangerouslySetInnerHTML={{
                      __html: i18n.t('banner.banner_text')
                    }}
                  />
                </Grid>
                <Grid item>
                  <Typography variant="body1">{isForeign ? <Trans i18nKey="banner.sub_title_foreign" /> : <Trans i18nKey="banner.sub_title_local" />}</Typography>
                </Grid>

                <Grid item>
                  <p>
                    {(!auth.loggedIn() || auth.isCandidate()) && !isForeign && (
                      <Link href={auth.loggedIn() ? '#search' : '/register'}>
                        <Button size="large" variant="contained" color="secondary" style={{ marginRight: '25px' }}>
                          <Trans i18nKey="banner.apply" />
                        </Button>
                      </Link>
                    )}

                    {(!auth.loggedIn() || auth.isCompany()) && !isForeign && (
                      <Link href={auth.loggedIn() ? '/job-offer/new' : '/entreprise/register'}>
                        <Button size="large" variant="outlined" style={{ marginRight: '25px', textTransform: 'initial' }}>
                          <Trans i18nKey="banner.publish_offer" />
                        </Button>
                      </Link>
                    )}

                    {!auth.loggedIn() && !auth.isCompany() && !auth.isCandidate() && isForeign && (
                      <Link href="/login">
                        <Button
                          id="homepage-hire-developer"
                          size="large"
                          variant="contained"
                          color="primary"
                          style={{
                            borderRaduis: '25px',
                            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                            color: 'white',
                            marginRight: '25px',
                            textTransform: 'initial'
                          }}>
                          <Trans i18nKey="banner.my_recruiter_account" />
                        </Button>
                      </Link>
                    )}
                  </p>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} sm={7}>
            <Hidden xsDown>
              <img src={isForeign ? '/Globe.png' : '/hero-banner-2.png'} style={{ width: '100%' }} alt="Illustration" />
            </Hidden>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default LandingPage
